import { render, staticRenderFns } from "./MainCard.vue?vue&type=template&id=3f3c8394"
import script from "./MainCard.vue?vue&type=script&lang=js"
export * from "./MainCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsPopup: require('/app/components/Commons/Popup.vue').default,Theme1Announcement: require('/app/components/Theme1/Announcement.vue').default,Theme1Slider: require('/app/components/Theme1/Slider.vue').default,Theme1MobileCards: require('/app/components/Theme1/Mobile/Cards.vue').default,Theme1DesktopCards: require('/app/components/Theme1/Desktop/Cards.vue').default})
